export enum E_NotificationCategories {
  PLATFORM_UPDATES = 'PLATFORM_UPDATES',
  ACTIVITY = 'ACTIVITY',
  ANNOUNCEMENTS = 'ANNOUNCEMENTS'
}
